import React from "react";

interface LoginWithButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
   iconSrc: string;
}

function LoginWithButton({iconSrc, ...otherProps}: LoginWithButtonProps) {
   return (
      <button
         className="w-full flex justify-start items-start  px-6 py-3 bg-primary-50 rounded-xl border border-primary-200 gap-6 dark:bg-dark-800 dark:border-white"
         {...otherProps}
      >
         <img className="w-6 h-6" src={iconSrc} alt="Social Icon" aria-hidden="true" />
         <span className="text-center text-primary-800 button-regular-semi-bold dark:text-primary-150">
            {otherProps.children}
         </span>
      </button>
   );
}

export default LoginWithButton;